import { useEffect, useState } from 'react'

export function useSecondsProgress(maxSeconds: number) {
	const [ms, setMs] = useState(0)

	const progress = ms / maxSeconds / 10

	useEffect(() => {
		const timeout = setTimeout(() => {
			setMs(ms + 100)
		}, 100)
		return () => clearTimeout(timeout)
	}, [ms, maxSeconds])

	let seconds = Math.round(ms / 1000)

	return [seconds, progress]
}

export function useTimeCounter(when: any) {
	const [count, setCount] = useState(0)
	useEffect(() => {
		if (when) {
			const timeout = setTimeout(() => {
				setCount(count + 1)
			}, 1000)
			return () => clearTimeout(timeout)
		} else {
			setCount(0)
		}
	}, [count, when])
	return count
}
